import { QuestionarioStatus } from '../../enum/questionario-status.enum';

/**
 * Status do questionário no contrato da API: "R" = rascunho, "P" = publicado.
 * Não há flag separada de rascunho — o status carrega essa informação.
 */
export const QUESTIONARIO_STATUS_RASCUNHO = 'R';
export const QUESTIONARIO_STATUS_PUBLICADO = 'P';

/** Os únicos códigos de status que a API aceita ao gravar um questionário. */
export type StatusQuestionarioApi =
  | typeof QUESTIONARIO_STATUS_RASCUNHO
  | typeof QUESTIONARIO_STATUS_PUBLICADO;

/**
 * Converte o status de domínio ("Rascunho"/"Publicado") para o código do contrato
 * ("R"/"P"). A API valida o param e responde 400 para qualquer outro valor — inclusive
 * string vazia — então "sem filtro" precisa virar `undefined` e não ser enviado.
 */
export function mapStatusDomainToApi(status?: string): string | undefined {
  if (status === QuestionarioStatus.Rascunho) return QUESTIONARIO_STATUS_RASCUNHO;
  if (status === QuestionarioStatus.Publicado) return QUESTIONARIO_STATUS_PUBLICADO;
  return undefined;
}
